"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "RenderPropSticky", {
  enumerable: true,
  get: function get() {
    return _renderPropsVersion.default;
  }
});
exports.default = void 0;

var _renderPropsVersion = _interopRequireDefault(require("./render-props-version"));

var _basicVersion = _interopRequireDefault(require("./basic-version"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _basicVersion.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-sticky-el/lib/index.js
// module id = 908
// module chunks = 0